export const selector = '.hero-home'

export default (
    el = null
) => {
    if (!el)
        return

    const items = el.querySelectorAll('.hero-home-item')

    if (!items)
        return

    console.groupCollapsed('[Hero] Home')

    const modal = el
        .querySelector('.modal')

    const modalWatch = (show) => {
        const embed = modal.querySelector('iframe')

        if (!embed)
            return

        const { src } = embed

        modal.addEventListener('hidden.bs.modal', () => {
            embed.setAttribute('src', '')
        })

        modal.addEventListener('show.bs.modal', () => {
            if (src && embed.src !== src)
                embed.setAttribute('src', src)
        })
    }

    const setHoverStatus = (e) => {
        if (window.innerWidth < 800)
            return

        const { target, type } = e
        const css = 'animating'
        const timing = 300

        if (!target || !type)
            return

        target.classList.add(css)

        setTimeout(() => target
            .classList.remove(css), timing)

        target.setAttribute('aria-expanded',
            type === 'mouseenter')
    }

    items.forEach(item => {
        item.addEventListener('mouseenter',
            setHoverStatus)

        item.addEventListener('mouseleave',
            setHoverStatus)
    })

    if (modal)
        modalWatch()

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                if (items)
                    items.forEach(item => {
                        item.removeEventListener('mouseenter',
                            setHoverStatus)

                        item.removeEventListener('mouseleave',
                            setHoverStatus)
                    })
            })

    // Log els
    console.log(el)

    console.groupEnd()

    return el
}
